import { useQuery } from '@tanstack/react-query';
import axios from '@/libs/axios';
export const me = () => {
  return axios.post('/info');
};
export const useMe = ({
  config
}) => {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => me(),
    ...config
  });
};